var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleType2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424 424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7200;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2451412019216"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54,350v56H18v-59c0-11.9,5.2-24.5,11.7-33.3,18.2-24.8,40.2-25.7,68.3-25.7s31.5,35,40,35,34-35,40-35c23.5,0,42.6-.3,60.3,16.7,9.5,9.1,19.7,24.2,19.7,42.3v59h-36v-56c0-10.9-17-10.4-17,1v55H71v-55c0-11.5-17-11.9-17-1h0Zm-8-73h-28V18h388v259h-176c-4.8,0-10.2-2.7-14.2-3.8-12.1-3.3-30.2-2.2-43.8-2.2s-23.7,23.1-34,30c-6.3-4.2-27.6-30-33-30-13.8,0-32.6-1.1-44.8,2.2-4,1.1-9.4,3.8-14.2,3.8ZM0,10v275c0,12.6,15.1,10,22,10-11.8,17.7-22,26.4-22,58v61c0,5.6,4.4,10,10,10h256c5.6,0,10-4.4,10-10v-60c0-13.1-2.4-24.1-6.3-33.7-5.7-14.3-8.9-15.1-15.7-25.3h157.1c4.2,0,6.7-.3,9-2,2-1.4,4-4.6,4-8V10c0-5.6-4.4-10-10-10H10C4.4,0,0,4.4,0,10h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81,181c0-7.9,2.6-17.6,5-23,5.4-12.1,15.9-23.4,28.4-28.6,20.9-8.7,41.7-6.7,59.4,7.8,6.8,5.6,11.3,10.3,15.9,20.1,17.1,36.6-9.7,80.7-51.7,80.7s-57-25.8-57-57h0Zm-17-5c0,19.6,1.9,33,14.4,49.6,2.5,3.3,5.4,7.1,8.3,9.7,35.2,30.7,84.9,23.2,106.7-4.8,14.7-18.9,18.6-28.1,18.6-54.4s-33.8-69-71-69-56.1,14.1-69.7,41.3c-3.5,7-7.3,17.8-7.3,27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238,126c0,4.9,4.1,9,9,9h124c15.9,0,13.1-18,1-18h-123c-6.2,0-11,2.9-11,9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238,77c0,5.4,2.4,9,8,9h127c12.3,0,10.4-17,2-17h-129c-4.8,0-8,3.2-8,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238,173c0,5.2,1.2,10,8,10h128c10.9,0,10.4-17-1-17h-126c-4.1,0-9,3.4-9,7h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleType2);
export default __webpack_public_path__ + "static/media/Role Type 2.c7fe95f11648e043318cb8ef91c77906.svg";
export { ForwardRef as ReactComponent };